import { useEffect } from "react";
import { App } from "@capacitor/app";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const WEB_WALLET = `${process.env.REACT_APP_BACKEND_URL}/wallet`;

// Android build: top-ups happen on the website, not inside the app.
export const WebTopupNotice = ({ onReturn }) => {
  useEffect(() => {
    const sub = App.addListener("resume", onReturn);
    return () => { sub.then((h) => h.remove()); };
  }, [onReturn]);

  return (
    <div data-testid="wallet-web-topup" className="space-y-3">
      <p className="text-sm text-[#9CA3AF]">
        Wallet top-ups are made on our website. Sign in with the same account and your new balance shows here when you come back.
      </p>
      <Button
        data-testid="wallet-web-topup-btn"
        onClick={() => { window.location.href = WEB_WALLET; }}
        className="h-11 rounded-xl bg-[#2563EB] hover:bg-[#1D4ED8] text-white"
      >
        <ExternalLink className="h-4 w-4 mr-2" /> Top up on notelosh.com
      </Button>
    </div>
  );
};
